import { mergeToNewObject } from '../../../util/helpers'
import { WALLET_RECEIVE } from '../../../constants/actions'

export const receiveProfile = (state = INITIAL_STATE, { type }) => {
  switch (type) {
    case WALLET_RECEIVE.ON_COPY_TO_CLIPBOARD:
      return mergeToNewObject(state, { copySuccessMsg: 'wallet.receive.copy-success' })

    case WALLET_RECEIVE.ON_RESET_STATE:
      return INITIAL_STATE

    default:
      return state
  }
}

const INITIAL_STATE = {
  copySuccessMsg: ''
}



// WEBPACK FOOTER //
// ./src/store/reducers/wallet/receive.js